import { z } from 'zod';

import { Transform } from '../generalPolicy/actions';

export const ADJUST_POLICY_QUESTION_ID = 'adjustPolicy';

export type AdjustPolicyAnswers = {
  adjustPolicy: {
    questionnaireTransform: Record<string, unknown>;
    reviewMonthlyPrice: number;
  };
  startDate: string;
};

export type AdjustPolicyOptionBaseProps = {
  title: string;
  description?: string;
  questionId: string;
  id: string;
  position: number;
};

export type AdjustPolicyCheckboxProps = AdjustPolicyOptionBaseProps & {
  checkboxOptions: CheckboxOption[];
};

export type CheckboxOption = {
  id: string | number;
  label: string;
  value: string;
};

export type AdjustPolicyOptionHorizontalSliderProps =
  AdjustPolicyOptionBaseProps & {
    amount: number;
  };

export type AdjustPolicyReturnValue = Record<string, unknown> & {
  reviewMonthlyPrice?: number;
  questionnaireTransform?: Transform;
};

export type AdjustPolicyConfig = {
  headerImage: { src: string; alt: string };
  title: string;
  checkboxPolicyOptions: AdjustPolicyCheckboxProps[];
};

export const BaseQuoteSchema = z.object({
  id: z.string(),
  price: z.number(),
  planId: z.string().nullish(),
  attributes: z.optional(
    z
      .object({
        addons: z.optional(
          z.union([z.array(z.string()), z.record(z.number())])
        ),
      })
      .nullish()
  ),
});

export type BaseQuote = z.infer<typeof BaseQuoteSchema>;

export const BaseQuestionnaireSchema = z.object({
  id: z.string(),
  answers: z
    .object({
      personalInfo: z.object({}).passthrough().nullish(),
      tariffInfo: z.object({}).passthrough().nullish(),
    })
    .passthrough(),
});

export type BaseQuestionnaire = z.infer<typeof BaseQuestionnaireSchema>;

export type PersonName = {
  firstName?: string;
  lastName?: string;
};

export const AdjustPolicyDtoSchema = z
  .object({
    adjustPolicy: z.object({
      reviewMonthlyPrice: z.number(),
    }),
    startDate: z.string(),

    questionnaireId: z.string(),
    quoteId: z.string(),
  })
  .transform(({ adjustPolicy: { reviewMonthlyPrice }, ...rest }) => ({
    ...rest,
    price: reviewMonthlyPrice,
  }));

export type AdjustPolicyDto = z.output<typeof AdjustPolicyDtoSchema>;
